import { LOGOUT_REQUEST } from '@sit/client-shared';
import isEqual from 'lodash/isEqual';
import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: [],
  error: null,
  loading: false,
  saving: false,
  initialLoad: false,
};

const deleteClusterNodeRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const deleteClusterNodeRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};
const deleteClusterNodeRequestSuccess = (state, payload) => {
  const { clusterId, nodeId } = payload.data;
  const data = [...state.data].map((cluster) => {
    if (cluster.id === clusterId) {
      const nodes = cluster.nodes.filter((node) => node.id !== nodeId);
      return { ...cluster, nodes };
    }
    return cluster;
  });
  data.unshift(payload.data.res);
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const getClustersRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getClustersRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};
const getClustersRequestSuccess = (state, payload) => {
  if (isEqual(payload.data, state.data))
    return {
      ...state,
      initialLoad: true,
    };
  return {
    ...state,
    data: payload.data,
    error: null,
    initialLoad: true,
    loading: false,
  };
};

const splitClusterRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const splitClusterRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};
const splitClusterRequestSuccess = (state, payload) => {
  const data = [...state.data].map((cluster) => {
    if (cluster.id === payload.data.clusterId) {
      cluster.nodes = cluster.nodes.filter((node) => !payload.data.nodeIds.includes(node.id));
    }
    return cluster;
  });
  data.unshift(payload.data.res);
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const updateClusterRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const updateClusterRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};
const updateClusterRequestSuccess = (state, payload) => {
  const data = [...state.data].map((c) => {
    return c.id === payload.data.id ? { ...payload.data } : c;
  });
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const updateClusterNodeRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const updateClusterNodeRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};
const updateClusterNodeRequestSuccess = (state, payload) => {
  const { clusterId, nodeId, res } = payload.data;
  const data = [...state.data].map((cluster) => {
    if (cluster.id === clusterId) {
      const nodes = cluster.nodes.map((node) => {
        return node.id === nodeId ? { ...res } : node;
      });
      return { ...cluster, edited: true, nodes };
    }
    return cluster;
  });
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const updateClusterOverlapsRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const updateClusterOverlapsRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    saving: false,
  };
};
const updateClusterOverlapsRequestSuccess = (state, payload) => {
  const { overlapsToUpdate } = payload.data;
  // find the node that is locked and release it
  const data = [...state.data].map((cluster) => {
    if (cluster.nodes && cluster.nodes.length > 0) {
      cluster.nodes.map((node, idx) => {
        if (node.overlaps && node.overlaps.length > 0) {
          node.overlaps.map((nodeOverlap, _idx) => {
            overlapsToUpdate.map((o) => {
              if (o.node_id === node.id && o.id === nodeOverlap.id) {
                cluster.nodes[idx].overlaps[_idx].isOverlapping = false;
              }
              return o;
            });
            return nodeOverlap;
          });
        }
        return node;
      });
    }
    return cluster;
  });
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const logoutRequest = () => initialState;

export default handleActions(
  {
    [types.DELETE_CLUSTER_NODE_REQUEST]: deleteClusterNodeRequest,
    [types.DELETE_CLUSTER_NODE_REQUEST_FAILURE]: deleteClusterNodeRequestFailure,
    [types.DELETE_CLUSTER_NODE_REQUEST_SUCCESS]: deleteClusterNodeRequestSuccess,
    [types.GET_CLUSTERS_REQUEST]: getClustersRequest,
    [types.GET_CLUSTERS_REQUEST_FAILURE]: getClustersRequestFailure,
    [types.GET_CLUSTERS_REQUEST_SUCCESS]: getClustersRequestSuccess,
    [types.SPLIT_CLUSTER_REQUEST]: splitClusterRequest,
    [types.SPLIT_CLUSTER_REQUEST_FAILURE]: splitClusterRequestFailure,
    [types.SPLIT_CLUSTER_REQUEST_SUCCESS]: splitClusterRequestSuccess,
    [types.SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST]: splitClusterRequest, // Use the same reducer as SPLIT_CLUSTER_REQUEST
    [types.SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_FAILURE]: splitClusterRequestFailure, // Use the same reducer as SPLIT_CLUSTER_REQUEST_FAILURE
    [types.SPLIT_CLUSTER_AND_ASSIGN_TO_ENTRY_REQUEST_SUCCESS]: splitClusterRequestSuccess, // Use the same reducer as SPLIT_CLUSTER_REQUEST_SUCCESS
    [types.UPDATE_CLUSTER_NODE_REQUEST]: updateClusterNodeRequest,
    [types.UPDATE_CLUSTER_NODE_REQUEST_FAILURE]: updateClusterNodeRequestFailure,
    [types.UPDATE_CLUSTER_NODE_REQUEST_SUCCESS]: updateClusterNodeRequestSuccess,
    [types.UPDATE_CLUSTER_OVERLAPS_REQUEST]: updateClusterOverlapsRequest,
    [types.UPDATE_CLUSTER_OVERLAPS_REQUEST_FAILURE]: updateClusterOverlapsRequestFailure,
    [types.UPDATE_CLUSTER_OVERLAPS_REQUEST_SUCCESS]: updateClusterOverlapsRequestSuccess,
    [types.UPDATE_CLUSTER_REQUEST]: updateClusterRequest,
    [types.UPDATE_CLUSTER_REQUEST_FAILURE]: updateClusterRequestFailure,
    [types.UPDATE_CLUSTER_REQUEST_SUCCESS]: updateClusterRequestSuccess,
    [LOGOUT_REQUEST]: logoutRequest,
  },
  initialState,
);
